export default __webpack_public_path__ + "9f9c434061443169f75ee7aac00aeeca.jpeg";